import { Injectable, Component } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalZipComponent } from './modal-zip/modal-zip.component';
import { MapGoogleMapComponent } from '../map-google-map/map-google-map.component';
import { NJDocData, childSearchReq, GoogleMapType } from '../DOData';
import { ModalSearchYouthComponent } from './modal-search-youth/modal-search-youth.component';
import { DiagnosisChildWindowComponent } from './diagnosis-child-window/diagnosis-child-window.component';
import { GenericTextBodyReaderComponent } from './generic-text-body-reader/generic-text-body-reader.component';
import { ModalCallIdSelectComponent } from'./modal-call-id-select/modal-call-id-select.component'
import { ModalPlanApprovalComponent } from './modal-plan-approval/modal-plan-approval.component';
import { ModalProgram4UserComponent } from './modal-program4-user/modal-program4-user.component';

interface Callback {
    (message: Array<NJDocData>): void;
}

@Injectable({
    providedIn: 'root'
})
export class wrappersService {
    modalRef: NgbModalRef;
    callback: Callback;
    closeResult: string;
    modalOptions: NgbModalOptions;
    constructor(private modalService: NgbModal) {
        this.modalOptions = {
            backdrop: 'static',
            backdropClass: 'customBackdrop'
        };
    }

    ///////////////////////////////////////////// Call Zip Modal /////////////////////////////////////////////
    //openZipComp(zip: string, _callback: Callback) {
    //    this.callback = _callback;
    //    this.modalRef = this.modalService.open(ModalZipComponent, this.modalOptions);
    //    this.modalRef.componentInstance.modal_zip_title = 'I am your title:';
    //    this.modalRef.componentInstance.modal_zip_content = 'I am your content';
    //    this.modalRef.componentInstance.zip = zip;
    //    this.modalRef.result.then((result) => {
    //        if (result) {
    //            console.log(result);
    //            this.callback(result);
    //        }
    //    }, (reason) => {
    //        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //        console.log(this.closeResult);
    //    });
    //}
    GetZipPromise(zip: string) {
        this.modalRef = this.modalService.open(ModalZipComponent, this.modalOptions);
        this.modalRef.componentInstance.modal_zip_title = 'City/County Selection';
        this.modalRef.componentInstance.modal_zip_content = 'Please select the correct city/county combination and click Accept.';
        this.modalRef.componentInstance.zip = zip;
        return this.modalRef;

    }
    ///////////////////////////////////////////// Call Zip Modal /////////////////////////////////////////////

    ///////////////////////////////////////////// Call ProgramsForUser Modal /////////////////////////////////////////////
   
    GetProgramsForUserPromise() {
        let ProgramsForModalOptions: NgbModalOptions;
        ProgramsForModalOptions = {
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            backdropClass: 'customBackdrop',
            windowClass: 'customModalClass'
        };
        this.modalRef = this.modalService.open(ModalProgram4UserComponent, ProgramsForModalOptions);
        this.modalRef.componentInstance.modal_zip_title = 'Select Organization Requiring Access to Document';
        this.modalRef.componentInstance.modal_zip_content = 'Select Program for Document*';
        
        return this.modalRef;

    }
    ///////////////////////////////////////////// Call ProgramsForUser Modal /////////////////////////////////////////////

    ///////////////////////////////////////////// Call Search Modal /////////////////////////////////////////////
    //openSearchComp(zip: string, _callback: Callback) {
    //    this.callback = _callback;
    //    this.modalRef = this.modalService.open(ModalZipComponent, this.modalOptions);
    //    this.modalRef.componentInstance.modal_zip_title = 'I am your title:';
    //    this.modalRef.componentInstance.modal_zip_content = 'I am your content';
    //    this.modalRef.componentInstance.zip = zip;
    //    this.modalRef.result.then((result) => {
    //        if (result) {
    //            console.log(result);
    //            this.callback(result);
    //        }
    //    }, (reason) => {
    //        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //        console.log(this.closeResult);
    //    });
    //}
    GetSearchPromise(param: childSearchReq) {
        let modalOptions: NgbModalOptions;  
        modalOptions = {
            backdrop: 'static',
            backdropClass: 'customBackdrop',
            windowClass: 'app-modal-window65',
            size:'lg'// see: ... \CyberAng_1_0_0\projects\ProviderDetailsRoot\src\styles.css
        };
        this.modalRef = this.modalService.open(ModalSearchYouthComponent, modalOptions);
        // dialog specific parameters to handle multiple template driven
        // diaglog
        this.modalRef.componentInstance.modal_search_title = param.title;
        this.modalRef.componentInstance.modal_search_content = param.content;
        this.modalRef.componentInstance.modal_tab = param.tab;
        this.modalRef.componentInstance.modal_gridTemplateCode = param.gridTemplateCode;
        this.modalRef.componentInstance.returnData = param.returnData;

        // core UI parameters
        this.modalRef.componentInstance.IDType = "";
        this.modalRef.componentInstance.MemberID = param.memberID;
        this.modalRef.componentInstance.FirstName = param.firstName;
        this.modalRef.componentInstance.LastName = param.lastName;
        this.modalRef.componentInstance.DOB = param.DOB;
        this.modalRef.componentInstance.SSN = param.SSN;
        this.modalRef.componentInstance.Age = param.Age;
        this.modalRef.componentInstance.Gender = param.Gender;
        this.modalRef.componentInstance.ParentName = param.ParentName;
        return this.modalRef;
    }
    ///////////////////////////////////////////// Call Search Modal /////////////////////////////////////////////

    getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
    /////////////////////////////////////////// Call goole map Modal /////////////////////////////////////////////
    //openGoogMapComp(map: string, _callback: Callback) {
    //    this.callback = _callback;

    //    let mapModalOptions: NgbModalOptions;
    //    mapModalOptions = {
    //        backdrop: 'static',
    //        backdropClass: 'customBackdrop',
    //        windowClass: 'app-modal-window65'
    //    };

    //    this.modalRef = this.modalService.open(MapGoogleMapComponent, mapModalOptions);
    //    this.modalRef.componentInstance.modal_map_title = 'I am your title:';
    //    this.modalRef.componentInstance.modal_map_content = 'I am your content';
    //    this.modalRef.componentInstance.map = map;
    //    this.modalRef.result.then((result) => {
    //        if (result) {
    //            console.log(result);
    //            this.callback(result);
    //        }
    //    }, (reason) => {
    //        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //        console.log(this.closeResult);
    //    });
    //}
    GetGoogMapPromise(param: GoogleMapType) {
        let mapModalOptions: NgbModalOptions;
        mapModalOptions = {
            backdrop: 'static',
            backdropClass: 'customBackdrop',
            windowClass: 'app-modal-window95'
        };

        this.modalRef = this.modalService.open(MapGoogleMapComponent, mapModalOptions);
        this.modalRef.componentInstance.modal_title = param.title;
        this.modalRef.componentInstance.modal_content = param.content;
        this.modalRef.componentInstance.tab = param.tab;
        this.modalRef.componentInstance.gridTemplateCode = param.gridTemplateCode;
        this.modalRef.componentInstance.providerSpecialty = param.providerSpecialty;
        this.modalRef.componentInstance.providerType = param.providerType;
        this.modalRef.componentInstance.program = param.program;
        this.modalRef.componentInstance.siteCIMIDS = param.siteCIMIDS;
        this.modalRef.componentInstance.siteCIMIDRequired = param.siteCIMIDRequired;
        this.modalRef.componentInstance.reOpenPopup = param.reOpenPopup;
        this.modalRef.componentInstance.MemberID = param.MemberID;
        return this.modalRef;
    }

    GetDiagnosisChildWindowPromise(params: any) {
        let mapModalOptions: NgbModalOptions;
        mapModalOptions = {
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            backdropClass: 'customBackdrop',
            windowClass: 'customModalClass'
        };
        this.modalRef = this.modalService.open(DiagnosisChildWindowComponent, mapModalOptions);
        this.modalRef.componentInstance.modal_title = params.title;
        this.modalRef.componentInstance.calledFrom = params.calledFrom;
        this.modalRef.componentInstance.calledFromID = params.calledFromID;
        return this.modalRef;

    }

    GetGenericTextBodyReaderPromise(params: any, size: string = 'lg') {
        let mapModalOptions: NgbModalOptions;
        mapModalOptions = {
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            backdropClass: 'customBackdrop',
            windowClass: 'customModalClass'
        };
        if (size == 'sm')
            mapModalOptions.size = 'sm';
        this.modalRef = this.modalService.open(GenericTextBodyReaderComponent, mapModalOptions);
        this.modalRef.componentInstance.modal_title = params.title;
        this.modalRef.componentInstance.selectedDiag = params.selectedDiag;
        return this.modalRef;
    }
    ///////////////////////////////////////////// Call Call Id Modal /////////////////////////////////////////////
    GetCallIdPromise() {
        // Fix for Ticket #32735
        let mapModalOptions: NgbModalOptions;
        mapModalOptions = {
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            backdropClass: 'customBackdrop',
            windowClass: 'customModalClass'
        };
        this.modalRef = this.modalService.open(ModalCallIdSelectComponent, mapModalOptions);
        // Fix for Ticket #32735 End
        this.modalRef.componentInstance.modal_zip_title = 'Associate a call...';
        this.modalRef.componentInstance.modal_zip_content = 'Please double click on a call record to associate with this form';
        // Wrapper loader has been set up with the grid to make the selection
        return this.modalRef;

    }
    ///////////////////////////////////////////// Call Call Id Modal /////////////////////////////////////////////

    GetPlanApprovalPromise() {
        let modalOptions: NgbModalOptions;
        modalOptions = {
            backdrop: 'static',
            backdropClass: 'customBackdrop',
            windowClass: 'app-modal-window65',
            size: 'lg'// see: ... \CyberAng_1_0_0\projects\ProviderDetailsRoot\src\styles.css
        };
        this.modalRef = this.modalService.open(ModalPlanApprovalComponent, modalOptions);
        // dialog specific parameters to handle multiple template driven
        // diaglog
        //this.modalRef.componentInstance.modal_search_title = param.title;
        //this.modalRef.componentInstance.modal_search_content = param.content;
        //this.modalRef.componentInstance.modal_tab = param.tab;
        //this.modalRef.componentInstance.modal_gridTemplateCode = param.gridTemplateCode;

        return this.modalRef;
    }
}